export default
    {
        path: "/amcheck",
        component: () => import('../view/amcheck/check.vue'),
        children: [
            {
                path: "",
                name: '',
                component: () => import('../view/amcheck/home.vue'),
                props: (route) => (
                    {
                        token: route.query.token,
                        deviceType: route.query.deviceType,
                        userId: route.query.userId,
                        secondLoginType: route.query.secondLoginType,
                        secondAssessToken: route.query.secondAssessToken,
                        deviceId: route.query.deviceId,
                    }
                ),
            },
            {
                path: "amdetail",
                name: 'amdetail',
                component: () => import('../view/amcheck/detail.vue'),
                props: (route) => (
                    {
                        token: route.query.token,
                        deviceType: route.query.deviceType,
                        userId: route.query.userId,
                        secondLoginType: route.query.secondLoginType,
                        secondAssessToken: route.query.secondAssessToken,
                        deviceId: route.query.deviceId,
                        checkId: route.query.checkId
                    }
                )
            },
            {
                path: "checkDetail",
                name: 'checkDetail',
                component: () => import('../view/amcheck/checkDetail.vue'),
                props: (route) => (
                    {
                        token: route.query.token,
                        deviceType: route.query.deviceType,
                        userId: route.query.userId,
                        secondLoginType: route.query.secondLoginType,
                        secondAssessToken: route.query.secondAssessToken,
                        deviceId: route.query.deviceId,
                        amId: route.query.amId,
                        checkId: route.query.checkId,
                        assetNo:route.query.assetNo,
                        assetNoReadonly:route.query.assetNoReadonly,

                    }
                )
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/amCheckRouter.js